import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'esl-pills',
  templateUrl: './esl-pills.component.html',
  styleUrls: ['./esl-pills.component.scss'],
})
export class EslPillsComponent implements OnInit {
  @Input() label: string;
  @Input() removable: boolean = false;
  @Input() disabled: boolean = false;
  @Input() icon: string;
  @Input() forceSmallScreenMode: boolean = false;
  @Input() clickable: boolean = false;
  @Input() visible: boolean = true;
  @Input() color: string = '';
  @Input() textColor: string = '';
  @Input() static: boolean = false;
  constructor() {}

  ngOnInit(): void {}
}
